import { createContext } from 'react';

/**
 * Куда ведут метки места в переписке в комментариях карточки диалога: минута отправки, как её
 * записывает метка, → id первого в порядке переписки элемента, отправленного в эту минуту.
 *
 * null — диалог не текстовая коммуникация: переписки у него нет, и запись вида метки — обычный текст.
 * Метки стоят и в комментариях правил заключения, и в комментариях значений атрибутов, а переписку
 * знает карточка целиком, поэтому цели раздаются контекстом, а не по цепочке пропов.
 */
export const MessageMarkTargetsContext = createContext<ReadonlyMap<string, number> | null>(null);
